import { Dispatch, FC, SetStateAction, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

type Props = {
  label: string;
  id: string;
  icon: string;
  mediaOption: string;
  setMediaOption: Dispatch<SetStateAction<string>>;
};

const MediaViewOption: FC<Props> = ({
  label,
  id,
  icon,
  mediaOption,
  setMediaOption,
}) => {
  const { isBigScreen } = useContext(ObjectPageContext);

  const active = id === mediaOption ? true : false;
  function setMediaOptionView(id: string) {
    setMediaOption(id);
    var url = window.location.href.split('#')[0];
    const newUrl = url + '#' + id;
    window.history.replaceState(null, null, newUrl);
  }
  return (
    <button
      onClick={() => setMediaOptionView(id)}
      className={`min-w-[120px] flex !basis-full flex-col lg:flex-row justify-center items-center gap-1 lg:gap-3 py-2 px-5 lg:px-8 transition ease duration-150 ${
        active
          ? 'font-icb bg-white lg:bg-white text-blue700 shadow-[0_0_10px_0_#c9c9c9] z-10 lg:shadow-none'
          : 'font-ic bg-grey10 lg:bg-blue700 text-grey300 lg:text-white'
      } lg:hover:bg-white lg:hover:text-blue700 lg:border-white lg:border-2 lg:rounded-md ${
        isBigScreen ? 'media-option-hover' : ''
      }`}
    >
      <img
        className={`${
          active
            ? 'filter-blue'
            : isBigScreen
            ? 'filter-white'
            : 'filter-dark-grey'
        } w-5`}
        src={icon}
        alt={`Ikon ${label}`}
      />
      <span className="whitespace-nowrap text-xs lg:text-base">{label}</span>
    </button>
  );
};

export default MediaViewOption;
